// Core
import React, { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

// Libraries
import { ThemeProvider } from 'styled-components';

// Routes
import Routes from './Routes';

// Store
import { getAppTheme } from './store/app/getters';
import { setAppTheme } from './store/app/actions';

// Plugins
import { appThemeClasses } from './plugins/general'; // @todo remove this after styled components migration

// Layout
import Layout from './layout/Layout';
import themeConfig from './config/theme';

// Components
import ConnectedAppController from './components/AppController';

// Project Styling (global)
import 'react-circular-progressbar/dist/styles.css';
import './style/main.scss';
import './style/App.scss';

const App = (props) => {
  const {
    setAppThemeAction,
    appThemeSlug,
  } = props;

  /** Sets the application theme */
  const setTheme = () => {
    const theme = process.env.REACT_APP_THEME;
    setAppThemeAction(theme);

    // Set theme on Body, since AntD places components outside .App
    for (const themeSlug in appThemeClasses) {
      if (themeSlug === theme) {
        document.getElementsByTagName('body')[0].classList.add(appThemeClasses[themeSlug]);
      } else {
        document.getElementsByTagName('body')[0].classList.remove(appThemeClasses[themeSlug]);
      }
    }
  };

  useEffect(() => {
    setTheme();
  }, []);

  // Theme
  const themeVariables = themeConfig[process.env.REACT_APP_THEME];

  const appClasses = ['App'];
  appClasses.push(appThemeClasses[appThemeSlug]);

  return (
    <BrowserRouter>
      <div className={appClasses.join(' ')}>
        <ThemeProvider theme={themeVariables}>
          <Layout>
            <ConnectedAppController>
              <Routes />
            </ConnectedAppController>
          </Layout>
        </ThemeProvider>
      </div>
    </BrowserRouter>
  );
};

App.propTypes = {
  appThemeSlug: PropTypes.string.isRequired,
  setAppThemeAction: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  appThemeSlug: getAppTheme(state, 'slug'),
});

const mapDispatchToProps = (dispatch) => ({
  setAppThemeAction: (theme) => dispatch(setAppTheme(theme)),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
